import * as Yup from 'yup';
import { useSnackbar } from 'notistack';

import React, { useEffect, useMemo, useState } from 'react';
import { Container, Button, Box, Grid, Typography, Stack } from '@mui/material';

import styled from '@emotion/styled';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import CircularProgress from '@mui/material/CircularProgress';

import { useRazorpay } from 'react-razorpay';
import { clearRazorPayInfo } from '../../server/store/inspectionBooking';
import { RHFTextField } from '../../hooks';
import { createChallan } from '../../server/api/inspectionBooking';
import { useDevice } from '../../hooks/useResponsive';
import { MetaHelmet } from '../../layouts/Helmet/Helmet';
import SubmitModal from '../popup';
import RHFPhoneFieldBlack from '../../hooks/rhf-phone-input-Black-theme';
import { getSettings } from '../../server/api/settings';

export default function ChallanPage() {
  const { isMobile } = useDevice();
  const dispatch = useDispatch();

  const Razorpay = useRazorpay();
  const { enqueueSnackbar } = useSnackbar();

  const { razorpayInfo, challanInfo, challanLoading, settings } = useSelector((state) => ({
    razorpayInfo: state.Inspection.razorpayInfo,
    razorpayLoading: state.Inspection.razorpayLoading,
    challanLoading: state.Inspection.challanLoading,
    challanInfo: state.Inspection.challanInfo,
    settings: state.settings.settings,
  }));

  // console.log('settings>>>>>>>>>>>>', settings?.payment?.encrypted_key_id);

  const [countryCode, setCountryCode] = useState('91');
  const [whatsappCountryCode, setWhatsappCountryCode] = useState('91');

  const navigate = useNavigate();
  const [modal, setModal] = React.useState(false);

  useEffect(() => {
    const credentials = {
      dispatch,
    };
    dispatch(getSettings(credentials));
  }, [dispatch]);

  const CustomButton = styled(Button)({
    background: '#F8971C',
    color: '#342C2C',
    borderRadius: '10px',
    height: '50px',
    boxShadow: '0 10px 10px rgba(0, 0, 0, 0.9)',
    fontSize: '21px',
    // fontWeight: '900',
    marginTop: '15px',
    '&:hover': {
      background: '#F8971C',
      color: '#342C2C',
    },
  });

  const CustomButtonWeb = styled(Button)({
    width: '25%',
    background: '#F8971C',
    color: '#342C2C',
    borderRadius: '10px',
    height: '40px',
    boxShadow: '0 10px 10px rgba(0, 0, 0, 0.9)',
    fontSize: '20px',
    // fontWeight: '900',
    marginTop: '15px',
    '&:hover': {
      background: '#F8971C',
      color: '#342C2C',
    },
  });

  const defaultValues = useMemo(() => ({}), []);

  const FormSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    description: Yup.string(),
    // phone: Yup.string()
    //   .length(countryCode === '968' ? 8 : 10, `Phone number must be exactly ${countryCode === '968' ? 8 : 10} digits`)
    //   .required('Phone number is required'),
    phone: Yup.string()
      .length(countryCode === '968' ? 8 : 10, `Phone number must be exactly ${countryCode === '968' ? 8 : 10} digits`)
      .required('Phone number is required'),
    whatsapp: Yup.string().length(
      whatsappCountryCode === '968' ? 8 : 10,
      `Whatsapp number must be exactly ${whatsappCountryCode === '968' ? 8 : 10} digits`
    ),
    amount: Yup.string(),
  });

  const methods = useForm({
    resolver: yupResolver(FormSchema),
    defaultValues,
  });
  // const { watch } = methods;

  // const phone = watch('phone');
  // const whatsapp = watch('whatsapp');

  // const expectedLength = countryCode === '968' ? 8 : 10;
  // const showLengthError = phone && phone.length !== expectedLength;
  // const showLengthWhatsappError = whatsapp && whatsapp.length !== expectedLength;

  const onSubmit = async (value, e) => {
    e?.preventDefault();
    // console.log(value);
    const credentials = {
      state: {
        name: value?.name,
        phone: value?.phone,
        country_code: countryCode,
        whatsapp: value?.whatsapp,
        whatsapp_country_code: whatsappCountryCode,
        description: value?.description,
        amount: value?.amount ? parseInt(value.amount, 10) : undefined,
        type: 'CHALLAN',
      },
      dispatch,
      navigate,
    };
    // console.log('credentials >>>>>', credentials);
    // dispatch(createChallan(credentials));
    try {
      const response = await dispatch(createChallan(credentials)).unwrap();
      if (response) {
        methods.reset({
          name: '',
          phone: '',
          description: '',
          amount: '',
          whatsapp: '',
        });
        setCountryCode('91');
        setWhatsappCountryCode('91');
      }
    } catch (error) {
      // Optionally handle error here
      console.error('Challan creation failed', error);
    }
  };
  useEffect(() => {
    if (razorpayInfo?.razorPayOrder) {
      dispatch(clearRazorPayInfo());
    }
  }, [dispatch, razorpayInfo?.razorPayOrder]);

  const razorpayOrderInfo = razorpayInfo?.razorPayOrder;

  // console.log('razorpayOrderInfo', challanInfo?._id);

  useEffect(() => {
    if (razorpayOrderInfo?.id && razorpayOrderInfo?.amount) {
      initiateRazorpayPayment();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [razorpayOrderInfo?.id]);

  const initiateRazorpayPayment = () => {
    if (!Razorpay) {
      enqueueSnackbar('Razorpay not available', { variant: 'error' });
      return;
    }

    const options = {
      key: settings?.payment?.encrypted_key_id,
      // 'rzp_live_IpvWyrTQ55Nreh',
      amount: razorpayOrderInfo?.amount,
      currency: razorpayOrderInfo?.currency,
      order_id: razorpayOrderInfo?.id,
      prefill: {
        name: challanInfo?.name,
        email: challanInfo?.email,
        contact: challanInfo?.phone,
        description: challanInfo?.description,
      },
      readonly: {
        email: true,
        contact: true,
      },
      // handler: async (res) => {
      //   console.log('response from razorpay', res);
      //   try {
      //     // dispatch(verifyRazorpayOrder(res));
      //     if (res.razorpay_payment_id) {
      //       if (challanInfo?._id) {
      //         navigate(`/challan-success-page/${challanInfo._id}`);
      //       }

      //       // router.push(paths.public.payment_successpage(purchase?._id));
      //     } else {
      //       navigate('/challan-fail-page');

      //       // router.push(paths.public.payment_failurepage(purchase?._id));
      //     }
      //   } catch (error) {
      //     enqueueSnackbar('payment verification failed, try again', { variant: 'error' });
      //     // router.push(paths.public.payment_failurepage(purchase?._id));
      //   }
      // },
      handler: async (res) => {
        console.log('response from razorpay', res);
        try {
          const storedChallan = JSON.parse(localStorage.getItem('challanInfo'));

          if (res.razorpay_payment_id && storedChallan?._id) {
            console.log('Navigating to success with ID:', storedChallan._id);
            navigate(`/challan-success-page/${storedChallan._id}`);
            localStorage.removeItem('challanInfo');
          } else {
            console.warn('Missing challanInfo or payment ID');
            navigate('/challan-fail-page');
          }
        } catch (error) {
          enqueueSnackbar('Payment verification failed, try again', { variant: 'error' });
          navigate('/challan-fail-page');
        }
      },

      notes: {
        address: 'Focus Motors',
      },
      theme: {
        color: '#3399cc',
      },
    };

    const rzpay = new window.Razorpay(options);
    rzpay.open();
  };

  return (
    <>
      <FormProvider {...methods}>
        <MetaHelmet title={'Challan'} companyName={'Focus Motors'} />
        <SubmitModal open={modal} close={() => setModal(false)} />
        <Box className="bg-color" sx={{ height: isMobile ? '70vh' : '80vh', display: 'flex', alignItems: 'center' }}>
          <Container maxWidth="lg" sx={{ padding: '0px 10px 0px 10px' }}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
              <Box px={{ xs: 1, sm: 2, md: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography fontSize={14} fontWeight={400} color="white">
                      Name{' '}
                      <Box component="span" sx={{ color: 'red' }}>
                        *
                      </Box>
                    </Typography>
                    <RHFTextField name="name" required placeholder="Name" type="text" fullWidth />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography fontSize={14} fontWeight={400} color="white">
                      Amount{' '}
                      <Box component="span" sx={{ color: 'red' }}>
                        *
                      </Box>
                    </Typography>

                    <RHFTextField
                      name="amount"
                      // label="Amount"
                      required
                      type="number"
                      size="small"
                      placeholder="Amount"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {/* <RHFTextField name="phone" required label="Phone Number" type="number" fullWidth /> */}
                    <Typography fontSize={14} fontWeight={400} color="white">
                      Phone{' '}
                      <Box component="span" sx={{ color: 'red' }}>
                        *
                      </Box>
                    </Typography>
                    <Stack spacing={1}>
                      <RHFPhoneFieldBlack
                        name="phone"
                        placeholder="Enter Phone Number"
                        required
                        countryCode={countryCode}
                        setCountryCode={setCountryCode}
                      />

                      {/* <Typography variant="caption" color={showLengthError ? 'error' : 'text.secondary'}>
                        {showLengthError && (
                          <span style={{ marginBottom: 2 }}>Phone number must be exactly {expectedLength} digits</span>
                        )}
                      </Typography> */}
                    </Stack>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {/* <RHFTextField name="phone" required label="Phone Number" type="number" fullWidth /> */}
                    <Typography fontSize={14} fontWeight={400} color="white">
                      Whatsapp{' '}
                      <Box component="span" sx={{ color: 'red' }}>
                        *
                      </Box>
                    </Typography>
                    <Stack spacing={1}>
                      <RHFPhoneFieldBlack
                        name="whatsapp"
                        placeholder="Enter Whatsapp Number"
                        countryCode={whatsappCountryCode}
                        setCountryCode={setWhatsappCountryCode}
                      />

                      {/* <Typography variant="caption" color={showLengthWhatsappError ? 'error' : 'text.secondary'}>
                        {showLengthWhatsappError && (
                          <span style={{ marginBottom: 2 }}>
                            Whatsapp number must be exactly {expectedLength} digits
                          </span>
                        )}
                      </Typography> */}
                    </Stack>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography fontSize={14} fontWeight={400} color="white">
                      Description{' '}
                    </Typography>
                    <RHFTextField name="description" placeholder="Description" required multiline rows={4} fullWidth />
                  </Grid>

                  <Grid item xs={12}>
                    {isMobile ? (
                      // <LoadingButton
                      //   type="submit"
                      //   variant="contained"
                      //   className="request-btn"
                      //   fullWidth
                      //   loading={challanLoading} // true = show spinner
                      // >
                      //   Create Challan
                      // </LoadingButton>
                      <CustomButton
                        type="submit"
                        variant="contained"
                        className="request-btn"
                        fullWidth
                        // disabled={challanLoading}
                      >
                        {challanLoading ? <CircularProgress size={24} sx={{ color: '#342C2C' }} /> : 'Pay Challan'}
                      </CustomButton>
                    ) : (
                      <Box display="flex" justifyContent="flex-end">
                        <CustomButtonWeb type="submit" variant="contained">
                          {challanLoading ? <CircularProgress size={24} sx={{ color: '#342C2C' }} /> : 'Pay Challan'}
                        </CustomButtonWeb>
                      </Box>
                    )}
                  </Grid>
                </Grid>
              </Box>
            </form>
          </Container>
        </Box>
      </FormProvider>
    </>
  );
}
